import { render } from "./WorksSection.vue?vue&type=template&id=24103784&scoped=true"
import script from "./WorksSection.vue?vue&type=script&lang=js"
export * from "./WorksSection.vue?vue&type=script&lang=js"

import "./WorksSection.vue?vue&type=style&index=0&id=24103784&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24103784"]])

export default __exports__